import { createSlice, type PayloadAction as IPayloadAction } from "@reduxjs/toolkit";
import type { IRootState } from "../app/store";

export type IProjectViewerState = {
  selectedFileFloorKeys: string[];
  zClipRangeM: {
    bottomM: number | null;
    topM: number | null;
  };
};

const initialState: IProjectViewerState = {
  selectedFileFloorKeys: [],
  zClipRangeM: {
    bottomM: null,
    topM: null,
  },
};

export const projectViewerSlice = createSlice({
  name: "projectViewer",
  initialState,
  reducers: {
    setSelectedFileFloorKeys: (state, action: IPayloadAction<string[]>) => {
      state.selectedFileFloorKeys = Array.from(new Set(action.payload));
    },
    toggleSelectedFileFloorKey: (state, action: IPayloadAction<string>) => {
      const fileFloorKey = action.payload;
      if (state.selectedFileFloorKeys.includes(fileFloorKey)) {
        state.selectedFileFloorKeys = state.selectedFileFloorKeys.filter(
          (key) => key !== fileFloorKey
        );
        return;
      }

      state.selectedFileFloorKeys.push(fileFloorKey);
    },
    clearSelectedFileFloorKeys: (state) => {
      state.selectedFileFloorKeys = [];
    },
    setProjectViewerZClipRangeM: (
      state,
      action: IPayloadAction<IProjectViewerState["zClipRangeM"]>
    ) => {
      state.zClipRangeM = action.payload;
    },
    updateProjectViewerZClipRangeM: (
      state,
      action: IPayloadAction<Partial<IProjectViewerState["zClipRangeM"]>>
    ) => {
      state.zClipRangeM = {
        ...state.zClipRangeM,
        ...action.payload,
      };
    },
  },
});

export const {
  setSelectedFileFloorKeys,
  toggleSelectedFileFloorKey,
  clearSelectedFileFloorKeys,
  setProjectViewerZClipRangeM,
  updateProjectViewerZClipRangeM,
} = projectViewerSlice.actions;

export const selectProjectViewerSelectedFileFloorKeys = (state: IRootState) =>
  state.projectViewer.selectedFileFloorKeys;

export const selectProjectViewerZClipRangeM = (state: IRootState) =>
  state.projectViewer.zClipRangeM;
